module.exports = require("@swa-ui/placements/src/Banner/BannerLayout1.module.scss");